<script>
import Modale from "../Modale.vue";

import { mapGetters } from "vuex";

export default {
  name: "Calendrier",
  props: ["mode", "isValidated"],
  components: {
    Modale,
  },
  data() {
    return {
      dateDisplayed: new Date(),
      daysMonth: [],
      daysFeries: [], //les jours fériés du mois en cours
      nbJoursOpen: 0,
      hovered: false,
      isAlsace: false,
      isModaleControleVisible: false,
      modaleInfos: [],
      modaleLoaded: false,
    };
  },
  computed: {
    ...mapGetters({
      username: "auth/username",
      agence: "auth/agence",
    }),
  },
  mounted() {
    //Est-ce que l'agence est au régime alsace moselle ?
    this.$axios
      .get("agences/" + this.$store.state.auth.currentAgence._id)
      .then((response) => {
        this.isAlsace = response.data.alsace;

        //Mise à jours des jours fériés pour les afficher en gris et les décompter
        this.majFeries(
          this.dateDisplayed.getUTCMonth(),
          this.dateDisplayed.getUTCFullYear()
        );

        //Initilisation des jours du mois
        this.JoursDuMois(this.dateDisplayed);
      })
      .catch((e) => console.log(e));
  },
  methods: {
    JoursDuMois(date) {
      let nbJoursMonth = 0;
      this.nbJoursOpen = 0;
      this.daysMonth = [];
      let myDate = new Date(date);

      //Nombre de jours dans le mois
      myDate.setUTCDate(1);
      myDate.setUTCMonth(myDate.getUTCMonth() + 1);
      myDate.setUTCDate(myDate.getUTCDate() - 1);
      nbJoursMonth = myDate.getUTCDate();

      //Déduire les weekends
      myDate = new Date(myDate.getUTCFullYear(), myDate.getUTCMonth(), 1, 12);

      //Calcul de la position du premier jour du mois au sein de la première semaine
      let nbBlanks = (myDate.getUTCDay() + 6) % 7;

      for (let i = 1; i <= nbJoursMonth; i++) {
        myDate.setUTCDate(i);

        //Remplir le tableau des jours dans le mois
        this.daysMonth[nbBlanks + i - 1] = new Date(myDate);

        //Mettre à jour le nombre de jours ouvrés
        if (myDate.getUTCDay() !== 0 && myDate.getUTCDay() !== 6) {
          this.nbJoursOpen = this.nbJoursOpen + 1;
        }
      }

      //Déduire les jours fériés des jours ouvrés
      this.daysFeries.forEach((e) => {
        if (e.getDay() !== 0 && e.getDay() !== 6) {
          this.nbJoursOpen = this.nbJoursOpen - 1;
        }
      });

      //Mettre à jour nbJoursOpen chez le parent
      this.$emit("nbJoursOpen", this.nbJoursOpen);
    },
    Semaine(date) {
      // 1er jour de l'année concernée par la date
      let init = new Date();
      init.setUTCMinutes(0);
      init.setUTCHours(0);
      init.setUTCDate(1);
      init.setUTCMonth(0);
      init.setUTCFullYear(date.getUTCFullYear());

      // Ecart entre la date recherchée et le premier jour de l'année de cette date
      let delta = date - init; //L'écart entre la date recherchée et le 1er janvier de cette année là, en milisecondes
      delta = Math.trunc(delta / 86400000); //Conversion en jours entiers, il y a 86400000 ms dans une journée

      // 1ère semaine de l'année : combien de jours
      let sem1 = ((7 - init.getUTCDay()) % 7) + 1;

      //Combien de semaines complètes intercallées entre la première et celle en cours (donc ces deux là exclues)
      let week = Math.trunc((delta - sem1) / 7);

      //J'ajoute un pour avoir le numéro de semaine en cours
      week = week + 1;

      //Si la première semaine fait plus de 4 jours (sem1 >=4) ET que je ne suis pas dans la première semaine (delta > sem1), j'ajoute 1 pour ajouter cette semaine là (voir semaine ISO sur wikipedia)
      if (sem1 >= 4 && delta >= sem1) {
        week = week + 1;
      }

      //Si je suis dans la dernière semaine de l'année (alors à ce stade week = 53, si week = 52 pas de pb, je veux éviter d'afficher une 53 qui n'en est pas une) et qu'elle fait moins de 4 jours, c'est alors la semaine n°1
      if (week == 53) {
        let final = new Date(init);
        final.setUTCFullYear(final.getUTCFullYear() + 1);
        final.setUTCDate(0);
        if (final.getUTCDay() != 0 && final.getUTCDay() < 4) {
          week = 1;
        }
      }

      //Si je suis dans la première semaine de l'année et qu'elle fait moins de 4 jours (donc au max 3 jours, donc delta < 3)
      if (delta < sem1 && sem1 < 4) {
        //Alors le numéro de semaine est égal au numéro de la dernière semaine de l'année précédente
        //Si la semaine commence par un jeudi elle comporte 53 semaine, de même si elle commence par un mercredi et qu'elle est bisextile
        init = new Date(init.setUTCFullYear(init.getUTCFullYear() - 1));
        let jourAnneePrecedente = init.getUTCDay();
        let annePrecedente = init.getUTCFullYear();
        if (
          jourAnneePrecedente == 4 ||
          (jourAnneePrecedente == 3 && annePrecedente % 4 == 0)
        ) {
          week = 53;
        } else {
          week = 52;
        }
      }

      return week;
    },
    Mois(date) {
      let monthList = [
        "Janvier",
        "Février",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juillet",
        "Août",
        "Septembre",
        "Octobre",
        "Novembre",
        "Décembre",
      ];
      let month = monthList[date.getUTCMonth()];

      return month;
    },
    Annee(date) {
      let annee = date.getUTCFullYear();
      return annee;
    },

    periodUp() {
      // Passer la date au premier jour du mois avant de changer le mois (sinon le 31 mars emmène au 31 avril, soit au premier Mai)
      this.dateDisplayed.setUTCDate(1);
      this.dateDisplayed = new Date(
        this.dateDisplayed.setUTCMonth(this.dateDisplayed.getUTCMonth() + 1)
      );

      //Mise à jours des jours fériés pour les afficher en gris et les décompter
      this.majFeries(
        this.dateDisplayed.getUTCMonth(),
        this.dateDisplayed.getUTCFullYear()
      );

      if (this.mode === "heures") {
        //J'envoi le lundi correspondant à la semaine à afficher - Idem periodUp
        let lundi = new Date(this.dateDisplayed);

        //Gestion du cas où le premier jour du mois est un dimanche (day = 0 au lieu de 7)
        if (this.dateDisplayed.getUTCDay() == 0) {
          lundi.setUTCDate(this.dateDisplayed.getUTCDate() - 7 + 1);
        } else {
          lundi.setUTCDate(
            this.dateDisplayed.getUTCDate() - this.dateDisplayed.getUTCDay() + 1
          );
        }

        this.$emit("changed", lundi);
      } else {
        // Passer la date au premier jour du mois avant de changer le mois (sinon le 31 mars emmène au 31 avril, soit au premier Mai)
        this.$emit("changed", this.dateDisplayed);
      }

      //Afficher les jours du calendrier
      this.JoursDuMois(this.dateDisplayed);
    },
    periodDown() {
      // Passer la date au premier jour du mois avant de changer le mois (sinon le 31 mars emmène au 31 avril, soit au premier Mai)
      this.dateDisplayed.setUTCDate(1);
      this.dateDisplayed = new Date(
        this.dateDisplayed.setUTCMonth(this.dateDisplayed.getUTCMonth() - 1)
      );

      //Mise à jours des jours fériés pour les afficher en gris et les décompter
      this.majFeries(
        this.dateDisplayed.getUTCMonth(),
        this.dateDisplayed.getUTCFullYear()
      );

      if (this.mode === "heures") {
        //J'envoi le lundi correspondant à la semaine à afficher - Idem periodUp
        let lundi = new Date(this.dateDisplayed);

        //Gestion du cas où le premier jour du mois est un dimanche (day = 0 au lieu de 7)
        if (this.dateDisplayed.getUTCDay() == 0) {
          lundi.setUTCDate(this.dateDisplayed.getUTCDate() - 7 + 1);
        } else {
          lundi.setUTCDate(
            this.dateDisplayed.getUTCDate() - this.dateDisplayed.getUTCDay() + 1
          );
        }

        this.$emit("changed", lundi);
      } else {
        this.$emit("changed", this.dateDisplayed);
      }

      //Afficher les jours du calendrier
      this.JoursDuMois(this.dateDisplayed);
    },
    periodReset() {
      this.dateDisplayed = new Date();

      //Mise à jours des jours fériés pour les afficher en gris et les décompter
      this.majFeries(
        this.dateDisplayed.getUTCMonth(),
        this.dateDisplayed.getUTCFullYear()
      );

      this.JoursDuMois(this.dateDisplayed);
      if (this.mode === "heures") {
        let lundi = new Date(this.dateDisplayed);
        //Gestion du cas où le premier jour du mois est un dimanche (day = 0 au lieu de 7)
        if (this.dateDisplayed.getUTCDay() == 0) {
          lundi.setUTCDate(this.dateDisplayed.getUTCDate() - 7 + 1);
        } else {
          lundi.setUTCDate(
            this.dateDisplayed.getUTCDate() - this.dateDisplayed.getUTCDay() + 1
          );
        }
        this.$emit("changed", lundi);
      } else {
        let firstMonthDay = new Date(this.dateDisplayed);
        firstMonthDay.setUTCDate(1);
        this.$emit("changed", firstMonthDay);
      }
    },
    goToWeek(evt) {
      if (this.mode === "heures") {
        // Le numéro de la semaine est indiquée dans la classe de l'évènement déclencheur
        let week = evt.target.classList[1].slice(-1);

        //Je fixe dateDisplayed au premier jour de cette nouvelle semaine (quelque soit sa position dans la semaine ou le nombre de jours de cette smeaine dans le mois)
        let firstDayOfWeekInMonth = this.daysMonth
          .slice((week - 1) * 7)
          .find((e) => e != undefined);
        this.dateDisplayed = new Date(firstDayOfWeekInMonth);

        //Je met à jour les dates de saisie
        let lundi = new Date(this.dateDisplayed);
        //Gestion du cas où le premier jour du mois est un dimanche (day = 0 au lieu de 7)
        if (this.dateDisplayed.getUTCDay() == 0) {
          lundi.setUTCDate(this.dateDisplayed.getUTCDate() - 7 + 1);
        } else {
          lundi.setUTCDate(
            this.dateDisplayed.getUTCDate() - this.dateDisplayed.getUTCDay() + 1
          );
        }
        this.$emit("changed", lundi);
      }
    },
    //Mettre à jour les jours fériés du mois en cours dans this.daysFeries[]
    majFeries(mois, an) {
      //Jours fixes
      let JourAn = new Date(an, "00", "01");
      let FeteTravail = new Date(an, "04", "01");
      let Victoire1945 = new Date(an, "04", "08");
      let FeteNationale = new Date(an, "06", "14");
      let Assomption = new Date(an, "07", "15");
      let Toussaint = new Date(an, "10", "01");
      let Armistice = new Date(an, "10", "11");
      let Noel = new Date(an, "11", "25");

      //jours mobiles
      let G = an % 19;
      let C = Math.floor(an / 100);
      let H =
        (C - Math.floor(C / 4) - Math.floor((8 * C + 13) / 25) + 19 * G + 15) %
        30;
      let I =
        H -
        Math.floor(H / 28) *
          (1 -
            Math.floor(H / 28) *
              Math.floor(29 / (H + 1)) *
              Math.floor((21 - G) / 11));
      let J = (an * 1 + Math.floor(an / 4) + I + 2 - C + Math.floor(C / 4)) % 7;
      let L = I - J;
      let MoisPaques = 3 + Math.floor((L + 40) / 44);
      let JourPaques = L + 28 - 31 * Math.floor(MoisPaques / 4);
      // let Paques = new Date(an, MoisPaques-1, JourPaques)
      let LundiPaques = new Date(an, MoisPaques - 1, JourPaques + 1);
      let Ascension = new Date(an, MoisPaques - 1, JourPaques + 39);
      // let Pentecote = new Date(an, MoisPaques-1, JourPaques+49)
      let LundiPentecote = new Date(an, MoisPaques - 1, JourPaques + 50);

      //Synthèse
      let synth = new Array(
        JourAn,
        LundiPaques,
        FeteTravail,
        Victoire1945,
        Ascension,
        LundiPentecote,
        FeteNationale,
        Assomption,
        Toussaint,
        Armistice,
        Noel
      );

      //Ajout des jours fériés personnalisés pour l'agence
      if (this.isAlsace) {
        let SaintEtienne = new Date(an, "11", "26");
        let VendrediSaint = new Date(an, MoisPaques - 1, JourPaques - 2);
        synth.push(SaintEtienne);
        synth.push(VendrediSaint);
      }

      //Tri des résultats uniquement pour le mois en cours
      let freeDays = [];
      synth.forEach((e) => {
        if (e.getMonth() == mois) {
          freeDays.push(e);
        }
      });

      this.daysFeries = freeDays;
    },

    cssDays(day) {
      //Style des weekends
      let weekend = "";
      if (day.getUTCDay() == 0 || day.getUTCDay() == 6) {
        weekend = "body__dayContainer__day__weekend";
      }

      //Style des jours fériés
      this.daysFeries.forEach((e) => {
        if (day.getUTCDate() == e.getDate()) {
          weekend = "body__dayContainer__day__weekend";
        }
      });

      //Style du jour "aujourd'hui"
      let today = "";
      if (
        day.getUTCDate() === new Date().getUTCDate() &&
        day.getUTCMonth() === new Date().getUTCMonth() &&
        day.getUTCFullYear() === new Date().getUTCFullYear()
      ) {
        weekend = ""; //Le CSS du fait d'être aujourd'hui prend le pas sur le fait d'être en weekend
        today = "body__dayContainer__day__today";
      }

      return weekend + today;
    },
    cssWeek(week) {
      let selected = "";

      if (this.mode == "heures") {
        //le numéro "week" correspond à la ligne dans le calendrier. Le style "body__highlight__n" est appliqué en conséquence pour placer la ligne au bon endroit dans le grid.
        let premierJourSemaine;
        let dernierJourSemaine;
        let dateCherchee = this.dateDisplayed.getUTCDate();

        if (week * 7 - 1 <= this.daysMonth.length - 1) {
          dernierJourSemaine = this.daysMonth[week * 7 - 1].getUTCDate();
          premierJourSemaine = dernierJourSemaine - 6;
        } else {
          dernierJourSemaine =
            this.daysMonth[this.daysMonth.length - 1].getUTCDate();
          premierJourSemaine = this.daysMonth[(week - 1) * 7].getUTCDate();
        }

        if (
          dateCherchee >= premierJourSemaine &&
          dateCherchee <= dernierJourSemaine
        ) {
          selected = " body__highlight__selected";
        }
      }

      return "body__highlight__" + week + selected;
    },
    nbWeeks() {
      //Le nombre de lignes de semaines affichées pour ce mois-ci dans le calendrier
      let nbweeks = this.daysMonth.length / 7;

      return nbweeks;
    },

    //Export PDF des heures du mois de l'ensemble des salariés
    async exportPdf() {
      //import des scripts pdfMake
      let pdfMake = require("pdfmake/build/pdfmake.js");
      if (pdfMake.vfs == undefined) {
        let pdfFonts = require("pdfmake/build/vfs_fonts.js");
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }

      //Récupération des données
      let users;
      await this.$axios
        .get(
          "saisieTemps/monthPdf/" +
            this.$store.state.auth.currentAgence._id +
            "/" +
            this.dateDisplayed
        )
        .then((response) => (users = response.data))
        .catch((err) => this.alert(err));

      //Déclaration du document
      let agenceName = this.agence;
      let monthList = [
        "Janvier",
        "Février",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juillet",
        "Août",
        "Septembre",
        "Octobre",
        "Novembre",
        "Décembre",
      ];
      let month = monthList[this.dateDisplayed.getUTCMonth()];
      let today = new Date();
      let currentUser = this.username;

      let docDefinition = {
        content: [
          {
            text:
              agenceName +
              " - " +
              month +
              " " +
              this.dateDisplayed.getUTCFullYear(),
            fontSize: 24,
          },
          { text: " ", fontSize: 30 }, //Saut de lignes
        ],
        //Footer : "Récapitulatif imprimé le --/--/-- à 00:00 par [username]"
        footer: function (currentPage, pageCount) {
          return [
            {
              text:
                "Récapitulatif imprimé le " +
                today.toISOString().slice(0, 10) +
                " par " +
                currentUser +
                " | Page " +
                currentPage +
                "/" +
                pageCount,
              alignment: "center",
            },
          ];
        },
      };

      for (const user of users) {
        docDefinition.content.push({
          text:
            user.name +
            " " +
            user.surname +
            " - " +
            user.total.toFixed(2) +
            " jrs (" +
            (user.ticketsRestaurant != undefined
              ? user.ticketsRestaurant + " TR"
              : "Saisie non validée !") +
            ")",
          bold: true,
        });

        //Total travaillé : temps en jours
        docDefinition.content.push({
          text: "Total travaillé : " + user.travail.toFixed(2) + " jrs",
        });

        //Absences
        for (const absence of user.absences) {
          docDefinition.content.push({
            text:
              "Absence (" +
              absence.name +
              ") : " +
              absence.volume.toFixed(2) +
              " jrs",
          });
        }

        //Saut de ligne
        docDefinition.content.push({ text: " ", fontSize: 10 });
      }

      //Export du fichier [aaaa.mm - Temps Mois.pdf]
      pdfMake
        .createPdf(docDefinition)
        .download(
          this.dateDisplayed.getUTCFullYear().toString() +
            "." +
            (
              (this.dateDisplayed.getUTCMonth() + 1 < 10 ? "0" : "") +
              (this.dateDisplayed.getUTCMonth() + 1)
            ).toString() +
            " - " +
            "Temps " +
            month +
            ".pdf "
        );
    },
    //Contrôle des saisies du mois.
    control() {
      let month = new Date(
        this.dateDisplayed.getFullYear(),
        this.dateDisplayed.getMonth(),
        1
      );

      this.$axios
        .get(
          "feuilles/getMonth/" +
            this.$store.state.auth.currentAgence._id +
            "/" +
            month
        )
        .then((response) => {
          this.modaleInfos = response.data;
          this.modaleLoaded = true;
        })
        .catch((err) => this.alert(err));

      this.isModaleControleVisible = true;
    },

    //Annuler la validation d'une feuille de saisie mensuelle pour un utilisateur afin qu'il puisse modifier sa saisie.
    undoValidation(feuilleId) {
      this.$axios
        .delete(
          "feuilles/" +
            this.$store.state.auth.currentAgence._id +
            "/" +
            feuilleId
        )
        .then((res) => {
          this.alert(res);
          this.modaleInfos.find(
            (e) => e.feuilleId == feuilleId
          ).validated = false;

          //Mettre à jour la page en arrière plan si c'est celle de l'user à qui l'on vient de dévalider.
          if (
            this.modaleInfos.find((e) => e.feuilleId == feuilleId)._id ==
            this.$store.state.auth.currentUser._id
          ) {
            this.$emit("unvalidated");
          }
        })
        .catch((err) => this.alert(err));
    },

    closeModale() {
      this.isModaleControleVisible = false;
      this.modaleInfos = [];
      this.modaleLoaded = false;
    },
  },
};
</script>

<template>
  <div class="calendrier">
    <!-- Contrôle des saisies -->
    <Modale v-if="isModaleControleVisible" @close="closeModale">
      <template v-slot:header>
        <span>Contrôle des saisies</span>
      </template>
      <template v-slot:body v-if="modaleLoaded">
        <div class="controle">
          <div
            v-for="user in modaleInfos"
            :key="user._id"
            class="controle-line"
          >
            <div
              class="controle-line-dot controle-line-dot-green"
              v-if="user.validated"
            ></div>
            <div class="controle-line-dot controle-line-dot-red" v-else></div>
            <span class="controle-line-text"> {{ user.name }} </span>
            <span class="controle-line-text"> {{ user.surname }} </span>
            <span class="controle-line-blank"></span>
            <span class="controle-line-number"> {{ user.jours }} </span>
            <span
              class="material-icons"
              v-if="user.validated"
              @click="
                $emit('printSingle', {
                  userId: user._id,
                  dateDisplayed: dateDisplayed,
                })
              "
              >print</span
            >
            <span class="material-icons controle-line-empty" v-else>clear</span>
            <span
              class="material-icons"
              v-if="user.validated"
              @click="undoValidation(user.feuilleId)"
              >undo</span
            >
            <span class="material-icons controle-line-empty" v-else>clear</span>
          </div>
        </div>
      </template>
      <template v-else v-slot:body> Chargement... </template>
    </Modale>

    <div class="header">
      <span class="material-icons header__arrow" @click="periodDown"
        >keyboard_arrow_left</span
      >
      <div class="header__text">
        <div id="month-label" class="header__text__mois">
          {{ Mois(dateDisplayed) }} {{ Annee(dateDisplayed) }}
        </div>
        <div v-if="mode == 'heures'" class="header__text__semaine">
          Semaine {{ Semaine(dateDisplayed) }}
        </div>
        <!-- <div v-if="mode == 'jours' " class="header__text__semaine"> {{JoursOpen(dateDisplayed)}} jours</div> -->
        <div v-if="mode == 'jours'" class="header__text__semaine">
          {{ nbJoursOpen }} jours
        </div>
      </div>
      <span class="material-icons header__arrow" @click="periodUp"
        >keyboard_arrow_right</span
      >
    </div>
    <div class="body">
      <div
        v-for="(day, index) in daysMonth"
        :key="'day_' + index"
        class="body__dayContainer"
      >
        <div v-if="day" class="body__dayContainer__day" :class="cssDays(day)">
          {{ day.getUTCDate() }}
        </div>
      </div>
      <!-- Un selecteur pour chaque semaine pour la navigation -->
      <div
        v-for="week in Math.ceil(this.daysMonth.length / 7)"
        :key="week"
        class="body__highlight"
        :class="cssWeek(week)"
        @click="goToWeek($event)"
      ></div>
    </div>
    <div class="footer">
      <span class="footer__element material-icons" @click="periodReset()">
        <div class="footer__element__label">Aujourd'hui</div>
        today
      </span>
      <span
        class="footer__element material-icons"
        @click="exportPdf()"
        v-if="can('lecture', 'tempsAdmin')"
      >
        <div class="footer__element__label">Synthèse mensuelle</div>
        print
      </span>
      <span
        v-else-if="isValidated"
        class="footer__element material-icons"
        @click="
          $emit('printSingle', {
            userId: $store.state.auth.currentUser._id,
            dateDisplayed: dateDisplayed,
          })
        "
      >
        <div class="footer__element__label">Imprimer</div>
        print
      </span>
      <span
        class="footer__element material-icons"
        @click="control()"
        v-if="can('lecture', 'tempsAdmin') && mode == 'jours'"
      >
        <div class="footer__element__label">Contrôle saisies</div>
        search
      </span>
    </div>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../assets/main.scss";

.calendrier {
  @include myBlock;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  align-self: start;
}

.header {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 60px;
  border-radius: 5px 5px 0 0;
  // background-color: $mainUltraLight;
  background: linear-gradient(90deg, $mainLight 0%, $mainUltraLight 75%);

  &__text {
    @include myFont;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 200px;

    &__mois {
      font-size: 18px;
      color: $main;
      font-weight: 600;
    }

    &__semaine {
      font-size: 16px;
      font-weight: 200;
      color: $main;
    }
  }

  &__arrow {
    cursor: pointer;
    color: $main;
    font-size: 40px;
    border-radius: 20px;
  }
}

.body {
  // border: red solid 1px;
  flex: 1;
  display: grid;
  grid-template-columns: repeat(7, 30px);
  grid-template-rows: repeat(6, 30px);
  gap: 7px 0px; //row-gap column-gap
  margin: 25px 0 5px 0;
  align-items: center;
  position: relative;

  &__dayContainer {
    // border: green solid 1px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &__day {
      @include myFont;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 13px;
      font-weight: 200;
      text-align: center;
      color: $black-bolder;
      height: 25px;
      width: 25px;

      &__weekend {
        color: $black-light;
      }

      &__today {
        // border: solid 1px $main;
        color: $main;
        font-weight: 800;
        // border: 1px solid $main;
        border-radius: 50px;
      }
    }
  }

  &__highlight {
    grid-column: 1 / span 7;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    border-radius: 8px;
    z-index: 10;

    &:hover {
      border: solid 1px $main;
      cursor: pointer;
    }

    &__1 {
      grid-row: 1 / span 1;
    }

    &__2 {
      grid-row: 2 / span 1;
    }

    &__3 {
      grid-row: 3 / span 1;
    }

    &__4 {
      grid-row: 4 / span 1;
    }

    &__5 {
      grid-row: 5 / span 1;
    }

    &__6 {
      grid-row: 6 / span 1;
    }

    &__selected {
      background-color: $main-bold;
      border: solid 1px $main-bold;
      opacity: 0.1;
    }
  }
}

.footer {
  position: relative;
  border-top: solid 1px $black-light;
  width: 80%;
  padding: 5px 0 15px 0;
  display: flex;
  justify-content: center;

  &__element {
    max-width: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 30px 0 30px;

    &:hover .footer__element__label {
      visibility: visible;
    }

    &__label {
      @include myFont;
      font-size: 11px;
      text-align: center;
      color: $color2;
      width: 120px;
      margin: 0 0 2px 0;
      visibility: hidden;
    }
  }
}

.controle {
  max-height: 70vh;
  scroll-behavior: smooth;
  overflow-y: auto;

  &-line {
    display: flex;
    align-items: center;

    &-dot {
      height: 10px;
      width: 10px;
      border-radius: 5px;
      margin-right: 15px;

      &-green {
        // background: rgb(15,50,15);
        // background: linear-gradient(324deg, rgba(25,70,25,1) 0%, rgba(35,189,61,1) 35%, rgba(70,250,120,1) 100%);
        background: $green;
      }

      &-red {
        // background: rgb(62,2,7);
        // background: linear-gradient(324deg, rgba(62,2,7,1) 0%, rgba(184,4,21,1) 35%, rgba(255,77,94,1) 100%);
        background: $alert;
      }
    }

    &-text {
      margin-right: 2px;
    }

    &-blank {
      flex: 1;
    }

    &-number {
      margin-right: 30px;
    }

    & > .material-icons {
      margin-right: 20px;
    }

    &-empty {
      color: white;
      cursor: default;

      &:hover {
        cursor: default;
        color: white;
      }
    }
  }
}
</style>
